// Components rendered on every page: header, footer, layout-level modals and
// partials included by them. Every page entry registers these too (they are
// async imports, so nothing is downloaded unless the tag is actually rendered).
export const GENERAL_COMPONENTS = {
	'search-input': () => import('../components/SeachInput'),
	'profile-button': () => import('../components/profileButton'),
	'notifications': () => import('../components/Notifications.vue'),
	'notifications-modal': () => import('../components/modals/NotificationsModal.vue'),
	'profile-option-modal': () => import('../components/modals/ProfileOptionModal.vue'),
	'currency-dropdown': () => import('../components/form-items/CurrencyDropdown'),
	'dropdown': () => import('../components/form-items/dropdown'),
	'get-an-offer': () => import('../components/GetAnOfferForm'),
	'book-appointment-modal': () => import('../components/modals/BookAppointmentModal.vue'),
	'contact-form': () => import('../components/ContactForm'),
	'exit-intent-popup': () => import('../components/ExitIntentPopup.vue'),
	'voice-chat': () => import('../components/VoiceChat.vue'),
	'player-button': () => import('../components/PlayerButton.vue'),
	'video-player-modal': () => import('../components/modals/VideoPlayerModal'),
};
